module.exports = __webpack_public_path__ + "static/media/54.8a898ec7.png";